import React from 'react'
import { Stack, Typography, List } from '@mui/material'
import { MultipleImageField } from '../../fields'
import { useRecordContext, useTranslate } from 'react-admin'
import { PROMOTIONS_FIELDS } from '../../../providers/localization/constant'
import get from 'lodash/get'

const PromotionImages: React.FC<{ source: string; title?: string; targetSourcePath?: string }> = ({
  source,
  title,
}) => {
  const record = useRecordContext()
  const files = get(record, source.split('.')[0])
  const translate = useTranslate()
  if (!files || files.length === 0) return null
  return (
    <Stack>
      <Typography variant='subtitle2' fontWeight={600}>
        {translate(`${PROMOTIONS_FIELDS}.images.label`)}
      </Typography>
      <List sx={{ width: '100%' }}>
        <MultipleImageField source={source} title={title} target='_blank' />
      </List>
    </Stack>
  )
}

export default PromotionImages
